import { createTheme, loadTheme } from "@fluentui/react";

export const classicTheme = createTheme({
  palette: {
    themePrimary: "#007AC3",
    themeLighterAlt: "#E6F2F9",
    themeLighter: "#DEEFFA",
    themeLight: "#CFEDFF",
    themeTertiary: "#019BF8",
    themeSecondary: "#0071B5",
    themeDarkAlt: "#005B92",
    themeDark: "#005B92",
    themeDarker: "#003D61",
    neutralLighterAlt: "#F6F6F6",
    neutralLighter: "#EDEDED",
    neutralLight: "#DADADA",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c6c4",
    neutralTertiary: "#a19f9d",
    neutralSecondary: "#605e5c",
    neutralPrimaryAlt: "#3b3a39",
    neutralPrimary: "#323130",
    neutralDark: "#201f1e",
    black: "#474747",
    white: "#ffffff",
  },
});

loadTheme({
  components: {
    TextField: {
      styles: {
        fieldGroup: {
          borderRadius: "4px",
          borderColor: "var(--color-black)",
          overflow: "hidden",
          ":after": {
            borderRadius: "4px",
            borderColor: "var(--color-blue) !important",
          },
        },
      },
    },
    Dropdown: {
      styles: {
        caretDownWrapper: {
          selectors: {
            ".ms-Dropdown-caretDown": {
              color: "var(--color-blue)",
              fontWeight: 1000,
            },
          },
        },
        dropdown: {
          selectors: {
            ".ms-Dropdown-title": {
              borderRadius: "4px",
              overflow: "hidden",
            },
          },
          ":focus::after": {
            borderRadius: "4px",
            borderColor: "var(--color-blue) !important",
          },
        },
      },
    },
    PrimaryButton: {
      styles: {
        root: {
          padding: "0 8px",
        },
        textContainer: {
          overflow: "hidden",
        },
        label: {
          overflow: "hidden",
          whiteSpace: "nowrap",
        },
      },
    },
  },
});
